<template>
    <ValidationObserver ref="validationObserver" slim>
        <div>
            <ProgressBar :currentStepIndex="0" />

            <div class="contentblock">
                <section class="contentblock__content">

                    <div class="pneu-offer__fieldgroup pneu-offer__fieldgroup--with-separator">
                        <div class="pneu-offer__fieldgroup-title">{{strings['PneuOffer.PickStationTitle']}}</div>
                        <SelectWithLabel v-model="selectedStationId"
                                         :label="strings['PneuOffer.PickStationTitle']"
                                         :options="stationOptions"
                                         rules="required" />
                        <br />
                        <a :href="settings['AutoServiceTsFinderUrl']">{{strings['PneuOffer.PickStationInfoText']}}</a>
                        <div v-if="settings['Promotion']" class="pneu-offer__promobanner">
                            <br />
                            <a :href="settings['Promotion'].PromotionPageUrl" target="_blank"><img :src="settings['Promotion'].BannerUrl" /></a>
                        </div>
                    </div>

                    <div class="pneu-offer__fieldgroup">
                        <div class="pneu-offer__fieldgroup-title">{{strings['PneuOffer.PickTyreTitle']}}</div>

                        <div class="pneu-offer__filter-row pneu-offer__filter-row--1">
                            <SelectWithLabel v-model="carTypeFilter"
                                             :label="strings['PneuOffer.CarType']"
                                             :options="carTypeOptions" />
                            <SelectWithLabel v-model="seasonFilter"
                                             :label="strings['PneuOffer.Season']"
                                             :options="seasonOptions" />
                        </div>

                        <div class="pneu-offer__filter-row pneu-offer__filter-row--2">
                            <SelectWithLabel v-model="widthFilter"
                                             :label="strings['PneuOffer.FilterWidth']"
                                             :options="widthOptions"
                                             :infoIconImageUrl="images['help-width']" />
                            <div class="pneu-offer__filter-dimension">/</div>
                            <SelectWithLabel v-model="heightFilter"
                                             :label="strings['PneuOffer.FilterHeight']"
                                             :options="heightOptions"
                                             :infoIconImageUrl="images['help-height']" />
                            <div class="pneu-offer__filter-dimension">R</div>
                            <SelectWithLabel v-model="rimSizeFilter"
                                             :label="strings['PneuOffer.FilterDiameter']"
                                             :options="rimSizeOptions"
                                             :infoIconImageUrl="images['help-rimsize']" />
                        </div>

                        <div class="pneu-offer__filter-row pneu-offer__filter-row--3">
                            <div class="pneu-offer__filter-col">
                                <SelectWithLabel v-model="brandFilter"
                                                 :label="strings['PneuOffer.FilterBrand']"
                                                 :options="brandOptions" />
                            </div>
                            <div class="pneu-offer__filter-col">
                                <SelectWithLabel v-model="speedIndexFilter"
                                                 :label="strings['PneuOffer.FilterSpeedIndex']"
                                                 :options="speedIndexOptions"
                                                 :infoIconImageUrl="images['help-speedindex']"/>
                                <Checkbox :label="strings['PneuOffer.FilterSpeedIndexGreater']" v-model="speedIndexFilterGreater" />
                            </div>
                            <div class="pneu-offer__filter-col">
                                <SelectWithLabel v-model="loadIndexFilter"
                                                 :label="strings['PneuOffer.FilterLoadIndex']"
                                                 :options="loadIndexOptions"
                                                 :infoIconImageUrl="images['help-loadindex']"/>
                                <Checkbox :label="strings['PneuOffer.FilterLoadIndexGreater']" v-model="loadIndexFilterGreater" />
                            </div>
                            <div class="pneu-offer__filter-col">
                                <SelectWithLabel v-model="runFlatFilter"
                                                 :label="strings['PneuOffer.FilterRunFlat']"
                                                 :options="runFlatOptions" />
                            </div>
                        </div>

                        <div class="pneu-offer__sku-list" v-if="skus && skus.length > 0">
                            <div class="pneu-offer__sku-list-title" ref="listTitle">{{numResultsTitle}}</div>
                            <div class="pneu-offer__sku-list-item" :class="{ 'pneu-offer__sku-list-item--aktion' : sku.DiscountPrice != null, 'pneu-offer__sku-list-item--selected' : selectedTyre && selectedTyre.EAN == sku.EAN }" v-for="sku in skus" :key="sku.EAN">
                                <img class="pneu-offer__sku-list-brand" :src="images['brand_' + sku.BrandID]" :alt="sku.BrandName" :title="sku.BrandName" />
                                <div class="pneu-offer__sku-list-name">
                                    <div class="pneu-offer__sku-list-item-brandname">{{sku.BrandName}}</div>
                                    <div class="pneu-offer__sku-list-item-title">{{sku.Title}}</div>
                                    <div class="pneu-offer__sku-list-item-description">{{sku.Description}}</div>
                                </div>
                                <div class="pneu-offer__sku-list-icons">
                                    <IconFuelEfficiency :category="sku.RollingResistanceClass" />
                                    <IconWetGrip :category="sku.WetGripClass" />
                                    <IconNoiseClass :category="sku.NoiseClass" :decibel="sku.NoisePerformance" />
                                    <IconSnow v-if="sku.Season != 'Summer'" />
                                </div>
                                <div class="pneu-offer__sku-list-SW">
                                    <div>
                                        {{strings['PneuOffer.MaxSpeed']}} {{sku.MaxSpeed}}<br />
                                        {{strings['PneuOffer.MaxWeight']}} {{sku.MaxWeight}}
                                    </div>
                                    <div>
                                        EAN {{sku.EAN}}
                                    </div>
                                </div>
                                <div class="pneu-offer__sku-list-price">
                                    <div v-if="sku.DiscountPrice">
                                        <div class="pneu-offer__sku-list-item-discount-price">{{sku.DiscountPrice | formatPrice}}</div>
                                        <div class="pneu-offer__sku-list-item-instead-of-price">{{strings['PneuOffer.DiscountInsteadOf']}} {{sku.Price | formatPrice}}</div>
                                    </div>
                                    <div class="pneu-offer__sku-list-item-price" v-else>{{sku.Price | formatPrice}}</div>
                                    <div class="pneu-offer__sku-list-item-mwst">{{strings['PneuOffer.PerPiece']}}, {{mwstIncludedText}}</div>
                                </div>
                                <div class="pneu-offer__sku-list-picker">
                                    <SelectWithLabel v-model="tyreAmount" :label="strings['PneuOffer.NumberOfTyres']" :options="tyreAmountOptions" />
                                    <button class="migrol-form__button migrol-form__button--green pneu-offer__btn-pick-tyre" @click="pickTyre(sku)">{{selectedTyre && selectedTyre.EAN == sku.EAN ? strings['Global.Continue'] : strings['PneuOffer.PickTyre']}}</button>
                                </div>
                            </div>
                        </div>
                        <div class="pneu-offer__sku-list-title" v-if="skus && skus.length === 0">{{strings['PneuOffer.NoResults']}}</div>
                        <Pager :currentPage="currentPage" :totalPages="totalPages" @pageChanged="pageChanged" />
                    </div>
                </section>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import { mapState, mapGetters, mapMutations } from 'vuex';
    import { CarTypes } from '@/utils/constants';
    import ProgressBar from './_common/ProgressBar';
    import IconFuelEfficiency from './_common/IconFuelEfficiency';
    import IconWetGrip from './_common/IconWetGrip';
    import IconNoiseClass from './_common/IconNoiseClass';
    import IconSnow from './_common/IconSnow';
    import { ValidationObserver } from 'VeeValidate'
    import { doValidation } from '@/utils/utils'
    import * as gaTracking from "@/utils/gaTracking";

    export default {
        data() {
            return {
                showDimensionHelp: false
            }
        },
        watch: {
            carTypeFilter(newVal) {
                switch (newVal) {
                    case CarTypes.PKW:
                        this.heightFilter = this.settings["PkwDefaultHeight"];
                        this.widthFilter = this.settings["PkwDefaultWidth"];
                        this.rimSizeFilter = this.settings["PkwDefaultRimSize"];
                        break;
                    case CarTypes.SUV:
                        this.heightFilter = this.settings["SuvDefaultHeight"];
                        this.widthFilter = this.settings["SuvDefaultWidth"];
                        this.rimSizeFilter = this.settings["SuvDefaultRimSize"];
                        break;
                    case CarTypes.LLKW:
                        this.heightFilter = this.settings["LkwDefaultHeight"];
                        this.widthFilter = this.settings["LkwDefaultWidth"];
                        this.rimSizeFilter = this.settings["LkwDefaultRimSize"];
                        break;
                }
            }
        },
        computed: {
            ...mapState([
                'strings',
                'enums',
                'settings',
                'images',
                'selectedTyre'
            ]),
            ...mapGetters([
                'mwstIncludedText'
            ]),

            seasonFilter: {
                get() { return this.$store.state.seasonFilter; },
                set(val) { this.$store.commit('setSeasonFilter', val); }
            },
            widthFilter: {
                get() { return this.$store.state.widthFilter; },
                set(val) { this.$store.commit('setWidthFilter', val); }
            },
            heightFilter: {
                get() { return this.$store.state.heightFilter; },
                set(val) { this.$store.commit('setHeightFilter', val); }
            },
            rimSizeFilter: {
                get() { return this.$store.state.rimSizeFilter; },
                set(val) { this.$store.commit('setRimSizeFilter', val); }
            },
            brandFilter: {
                get() { return this.$store.state.brandFilter; },
                set(val) { this.$store.commit('setBrandFilter', val); }
            },
            speedIndexFilter: {
                get() { return this.$store.state.speedIndexFilter; },
                set(val) { this.$store.commit('setSpeedIndexFilter', val); }
            },
            speedIndexFilterGreater: {
                get() { return this.$store.state.speedIndexFilterGreater; },
                set(val) { this.$store.commit('setSpeedIndexFilterGreater', val); }
            },
            loadIndexFilter: {
                get() { return this.$store.state.loadIndexFilter; },
                set(val) { this.$store.commit('setLoadIndexFilter', val); }
            },
            loadIndexFilterGreater: {
                get() { return this.$store.state.loadIndexFilterGreater; },
                set(val) { this.$store.commit('setLoadIndexFilterGreater', val); }
            },
            runFlatFilter: {
                get() { return this.$store.state.runFlatFilter; },
                set(val) { this.$store.commit('setRunFlatFilter', val); }
            },
            skus: {
                get() { return this.$store.state.skus; },
                set(val) { this.$store.commit('setSkus', val); }
            },
            currentPage: {
                get() { return this.$store.state.currentPage; },
                set(val) { this.$store.commit('setCurrentPage', val); }
            },
            totalPages: {
                get() { return this.$store.state.totalPages; },
                set(val) { this.$store.commit('setTotalPages', val); }
            },
            totalResults: {
                get() { return this.$store.state.totalResults; },
                set(val) { this.$store.commit('setTotalResults', val); }
            },
            stationOptions() {
                return this.settings['AvailableStations'].map((val) => { return { text: val.text, id: val.id } });
            },
            selectedStationId: {
                get() { return this.$store.state.selectedStationId; },
                set(id) { this.setSelectedStationId(id); }
            },
            widthOptions() {
                return this.settings['AvailableWidths'].map((val) => { return { text: val, id: val } });
            },
            heightOptions() {
                return this.settings['AvailableHeights'].map((val) => { return { text: val, id: val } });
            },
            rimSizeOptions() {
                return this.settings['AvailableRimSizes'].map((val) => { return { text: val, id: val } });
            },
            brandOptions() {
                var brands = this.settings['AvailableBrands'].map((val) => { return { text: val.Name, id: val.ID } });
                brands.unshift({ text: this.strings['Global.All'], id: null });
                return brands;
            },
            speedIndexOptions() {
                var speedIndexes = this.settings['AvailableSpeedIndexes'].map((val) => { return { text: val.Name, id: val.ID } });
                speedIndexes.unshift({ text: this.strings['Global.All'], id: null });
                return speedIndexes;
            },
            loadIndexOptions() {
                var loadIndexes = this.settings['AvailableLoadIndexes'].map((val) => { return { text: val.Name, id: val.ID } });
                loadIndexes.unshift({ text: this.strings['Global.All'], id: null });
                return loadIndexes;
            },
            runFlatOptions() {
                return [
                    { text: this.strings['Global.All'], id: null },
                    { text: this.strings['Global.Yes'], id: true },
                    { text: this.strings['Global.No'], id: false },
                ];
            },
            seasonOptions() {
                var seasons = this.enums['Seasons'].map((val) => { return { text: val.text, id: val.value } });
                seasons.unshift({ text: this.strings['Global.All'], value: null });
                return seasons;
            },
            tyreAmountOptions() {
                return [
                    { text: '2 ' + this.strings['PneuOffer.Pieces'], id: 2 },
                    { text: '4 ' + this.strings['PneuOffer.Pieces'], id: 4 }
                ];
            },
            tyreAmount: {
                get() { return this.$store.state.tyreAmount; },
                set(amount) { this.setTyreAmount(amount); }
            },
            carTypeOptions() {
                return this.enums['CarTypes'].map((val) => { return { text: val.text, id: val.value } });
            },
            carTypeFilter: {
                get() { return this.$store.state.carType; },
                set(type) { this.setCarType(type); }
            },
            numResultsTitle() {
                return this.totalResults > 0 ? this.strings['PneuOffer.SkuListTitle'].replace('###', this.totalResults) : '';
            }
        },
        methods: {
            ...mapMutations([
                'setSelectedStationId',
                'setSelectedTyre',
                'setTyreAmount',
                'setCarType',
                'setSeasonFilter',
                'setWidthFilter',
                'setHeightFilter',
                'setRimSizeFilter',
                'setBrandFilter',
                'setRunFlatFilter',
                'setSkus',
                'setCurrentPage',
                'setTotalPages',
                'setTotalResults',
            ]),
            pageChanged(page) {
                this.currentPage = page;
                this.$refs.listTitle.scrollIntoView({ behavior: "smooth", block: "start" });
            },
            pickTyre(tyre) {
                var vm = this;
                doValidation(vm.$refs.validationObserver, () => {
                    vm.setSelectedTyre(tyre);
                    gaTracking.trackSelectItem(tyre, this.$store.state);
                    vm.$router.push('/step2').catch(() => { });
                });
            },
            wrapInDiv(input) {
                return "<div>" + input + "</div>";
            }
        },
        mounted() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            var that = this;

            if (!that.carTypeFilter)
                that.carTypeFilter = CarTypes.PKW;
            if (!that.seasonFilter)
                that.seasonFilter = this.settings["DefaultSeason"];
            if (!that.heightFilter)
                that.heightFilter = this.settings["PkwDefaultHeight"];
            if (!that.widthFilter)
                that.widthFilter = this.settings["PkwDefaultWidth"];
            if (!that.rimSizeFilter)
                that.rimSizeFilter = this.settings["PkwDefaultRimSize"];

            //add watcher to all filter properties
            that.$watch(vm =>
                [
                    vm.currentPage,
                    vm.seasonFilter,
                    vm.carTypeFilter,
                    vm.widthFilter,
                    vm.heightFilter,
                    vm.rimSizeFilter,
                    vm.brandFilter,
                    vm.speedIndexFilter,
                    vm.speedIndexFilterGreater,
                    vm.loadIndexFilter,
                    vm.loadIndexFilterGreater,
                    vm.runFlatFilter
                ],
                (oldVal, newVal) => {

                    if (oldVal && newVal && oldVal[0] == newVal[0])
                        that.currentPage = 1; //current page has not changed, which means some other property has changed -> reset currentPage to 1

                    //load skus from server
                    let query = new URLSearchParams();

                    query.append('page', that.currentPage);
                    query.append('carType', that.carTypeFilter);
                    query.append('width', that.widthFilter);
                    query.append('height', that.heightFilter);
                    query.append('rimSizeInch', that.rimSizeFilter);

                    if (that.seasonFilter != null)
                        query.append('season', that.seasonFilter);

                    if (that.brandFilter != null)
                        query.append('brandId', that.brandFilter);

                    if (that.speedIndexFilter != null)
                        query.append('speedIndex', that.speedIndexFilter);

                    if (that.speedIndexFilterGreater != null)
                        query.append('speedIndexGreater', that.speedIndexFilterGreater);

                    if (that.loadIndexFilter != null)
                        query.append('loadIndex', that.loadIndexFilter);

                    if (that.loadIndexFilterGreater != null)
                        query.append('loadIndexGreater', that.loadIndexFilterGreater);

                    if (that.runFlatFilter != null)
                        query.append('isRunFlat', that.runFlatFilter);

                    fetch("/migrolapi/de/pneuoffer/search?" + query.toString())
                        .then(response => response.json())
                        .then(result => {
                            that.skus = result.Skus;
                            that.totalPages = result.NumPages;
                            that.totalResults = result.TotalResults;
                            gaTracking.trackViewItem(result.Skus, this.$store.state);
                        });
                }, {
                immediate: true
            });
        },
        components: {
            ValidationObserver,
            ProgressBar,
            IconFuelEfficiency,
            IconWetGrip,
            IconNoiseClass,
            IconSnow
        }
    };
</script>